import { render } from "./CIS-Partners.vue?vue&type=template&id=390f3697&scoped=true"
import script from "./CIS-Partners.vue?vue&type=script&lang=js"
export * from "./CIS-Partners.vue?vue&type=script&lang=js"

import "./CIS-Partners.vue?vue&type=style&index=0&id=390f3697&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-390f3697"]])

export default __exports__